export default "__VITE_ASSET__TiXOoD2F__"